import type { ApolloCache } from "@apollo/client/cache"

import { evict } from "shared/api/evict"
import { ProjectTypename } from "shared/types/Project"

import { restoreProjectSorting } from "./restoreProjectSorting"

export function evictProjectAndSort(id: string, cache: ApolloCache<object>) {
  evict({ cache, id, typename: ProjectTypename })
  restoreProjectSorting(cache)
}
